import Vue from "vue";
import VueRouter from "vue-router";

import { isAuth } from "@/services/user";
import store from "@/store";

Vue.use(VueRouter);

export const LOGIN_PAGE = "login";
export const MONITOR_PAGE = "monitor";
export const QUESTION_PAGE = "qa";
export const END_PAGE = "end";

const routes = [
  {
    path: "/", // 检查登录权限。如果已登陆则跳到监控页面
    name: LOGIN_PAGE,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/index.vue")
  },
  {
    path: "/monitor",
    name: MONITOR_PAGE,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/monitor/index.vue")
  },
  {
    path: "/qa",
    name: QUESTION_PAGE,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/qa/index.vue")
  },
  {
    path: "/end",
    name: END_PAGE,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/end/index.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  routes
});

router.beforeEach((to, from, next) => {
  if (END_PAGE !== to.name && store.state.meetingEnd) {
    next({ name: END_PAGE });
  } else if (LOGIN_PAGE !== to.name && !isAuth()) {
    // 检查是否已登录，如果没有登录 跳转到login页面
    next({ name: LOGIN_PAGE });
  } else {
    next();
  }
});

export default router;
